import { formatDistance } from 'date-fns';

const COUNTDOWN_FROM_SECONDS = 30;

export const formatClockTime = (epochMs: number): string =>
  new Date(epochMs).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });

// Approximate ("about 1 minute", "2 minutes") until the last seconds, then an exact count.
export const formatRemaining = (ms: number): string => {
  const seconds = Math.max(Math.ceil(ms / 1000), 0);
  if (seconds <= COUNTDOWN_FROM_SECONDS) return `${seconds} ${seconds === 1 ? 'second' : 'seconds'}`;

  const now = Date.now();
  return formatDistance(now + ms, now);
};
